import React from "react";

type Props = {
  showEuclideanRank: boolean;
  showCosineRank: boolean;
  showFeatureData: boolean;
  showAverageLighthouseCorrelScore: boolean;
  onValueChange: (next: {
    showFeatureData: boolean;
    showEuclideanRank: boolean;
    showCosineRank: boolean;
    showAverageLighthouseCorrelScore: boolean;
  }) => void;
};

export function ColumnToggles({
  showFeatureData,
  showEuclideanRank,
  showCosineRank,
  showAverageLighthouseCorrelScore,
  onValueChange,
}: Props) {
  return (
    <div className="flex items-center gap-6">
      <label className="inline-flex items-center gap-2">
        <input
          type="checkbox"
          className="h-4 w-4"
          checked={showFeatureData}
          onChange={(e) =>
            onValueChange({
              showEuclideanRank,
              showCosineRank,
              showFeatureData: e.target.checked,
              showAverageLighthouseCorrelScore,
            })
          }
        />
        <span>Show Feature Data</span>
      </label>

      <label className="inline-flex items-center gap-2">
        <input
          type="checkbox"
          className="h-4 w-4"
          checked={showEuclideanRank}
          onChange={(e) =>
            onValueChange({
              showEuclideanRank: e.target.checked,
              showCosineRank,
              showFeatureData,
              showAverageLighthouseCorrelScore,
            })
          }
        />
        <span>Show euclideanRank</span>
      </label>
      <label className="inline-flex items-center gap-2">
        <input
          type="checkbox"
          className="h-4 w-4"
          checked={showCosineRank}
          onChange={(e) =>
            onValueChange({
              showEuclideanRank,
              showCosineRank: e.target.checked,
              showFeatureData,
              showAverageLighthouseCorrelScore,
            })
          }
        />
        <span>Show cosineRank</span>
      </label>
      <label className="inline-flex items-center gap-2">
        <input
          type="checkbox"
          className="h-4 w-4"
          checked={showAverageLighthouseCorrelScore}
          onChange={(e) =>
            onValueChange({
              showEuclideanRank,
              showCosineRank,
              showFeatureData,
              showAverageLighthouseCorrelScore: e.target.checked,
            })
          }
        />
        <span>Show avgCorrel</span>
      </label>
    </div>
  );
}
